/**
 * Service to handle file downloads.
 */
const DownloadService = {
  /**
   * Downloads a file from a URL.
   * @param {string} url - The URL of the file to download.
   * @param {string} filename - The name to save the file as.
   */
  downloadFile: async (url, filename = "document") => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      // Fallback: Open in new tab if blob download fails (e.g. CORS issues)
      window.open(url, "_blank");
    }
  },
};

export default DownloadService;
